
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "4755c1536b8af500df363acdf41ff82452cfd044",
  "nuxt": {
    "buildId": "42f9194b-5ccf-436d-872f-6ad0ece45d1d"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
